// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphqlTag = require("graphql-tag").default;
var ReactApollo = require("react-apollo");
var ReasonApolloUtils = require("../ReasonApolloUtils.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function Make(Config) {
  var graphQLSubscriptionAST = Curry._1(GraphqlTag, Config.query);
  var apolloDataToVariant = function (apolloData) {
    var match = apolloData.loading;
    var match$1 = ReasonApolloUtils.getNonEmptyObj(apolloData.data);
    var match$2 = apolloData.error;
    if (match) {
      return "Loading";
    } else if (match$1 !== undefined) {
      return {
              TAG: "Data",
              _0: Curry._1(Config.parse, match$1)
            };
    } else if (match$2 == null) {
      return {
              TAG: "Error",
              _0: {
                message: "No data",
                graphQLErrors: null,
                networkError: null
              }
            };
    } else {
      return {
              TAG: "Error",
              _0: match$2
            };
    }
  };
  var convertJsInputToReason = function (apolloData) {
    var data = ReasonApolloUtils.getNonEmptyObj(apolloData.data);
    var tmp;
    if (data !== undefined) {
      var exit = 0;
      var parsedData;
      try {
        parsedData = Curry._1(Config.parse, data);
        exit = 1;
      }
      catch (exn){
        tmp = undefined;
      }
      if (exit === 1) {
        tmp = Caml_option.some(parsedData);
      }
      
    } else {
      tmp = undefined;
    }
    var error = apolloData.error;
    return {
            result: apolloDataToVariant(apolloData),
            data: tmp,
            error: !(error == null) ? error : undefined,
            loading: apolloData.loading
          };
  };
  var JsSubscription = {};
  var ReasonApolloSubscription$Make = function (props) {
    var children = props.children;
    return JsxRuntime.jsx(ReactApollo.Subscription, {
                subscription: graphQLSubscriptionAST,
                variables: props.variables,
                children: (function (apolloData) {
                    return Curry._1(children, convertJsInputToReason(apolloData));
                  })
              });
  };
  return {
          graphQLSubscriptionAST: graphQLSubscriptionAST,
          apolloDataToVariant: apolloDataToVariant,
          convertJsInputToReason: convertJsInputToReason,
          JsSubscription: JsSubscription,
          make: ReasonApolloSubscription$Make
        };
}

exports.Make = Make;
/* graphql-tag Not a pure module */
